import { useState, useEffect } from 'react';

export default function useIsDev(isAuthenticated) {
  const [isDev, setIsDev] = useState(false);
  useEffect(() => {
    if (isAuthenticated) {
      const hostname = window.location.hostname;
      if (hostname.includes('localhost') || hostname.includes('dev')) {
        setIsDev(true);
      }
    }
  }, [isAuthenticated]);
  return isDev;
}
